module.exports = __webpack_public_path__ + "img/vistastudent.09c9f566.svg";